<ng-container *ngFor="let item of items">
  <div [class]="item.data.css">
    <tmo-dynamic [item]="item.dynamicItem"></tmo-dynamic>
  </div>
</ng-container>
